import { logUsage } from 'owa-analytics';
import { confirm } from 'owa-confirm-dialog';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import getSelectedData from 'owa-editor/lib/utils/getSelectedData';
import { BrowseCloudLocationsHyperLink, CouldNotInsertHyperLinkTitle } from 'owa-insert-link';
import loc from 'owa-localize';
import { closeButtonLabel } from 'owa-locstrings/lib/strings/closebuttonlabel.locstring.json';

export async function checkUserSelectionText(
    editorViewState: EditorViewState
): Promise<{ shouldContinue: boolean; selectionText: string | undefined }> {
    const selectedData = getSelectedData(editorViewState);
    if (selectedData?.data) {
        if (selectedData.data.indexOf('<') === -1) {
            // User has selected pure text
            return { shouldContinue: true, selectionText: selectedData.data };
        } else {
            // User has selected complex data which doesn't support insert link
            logUsage('HyperlinkUnsupportedContent');
            await confirm(
                loc(CouldNotInsertHyperLinkTitle),
                loc(BrowseCloudLocationsHyperLink),
                false /*resolveImmediately*/,
                {
                    hideCancelButton: true,
                    okText: loc(closeButtonLabel),
                }
            );
            return { shouldContinue: false, selectionText: undefined };
        }
    }

    return { shouldContinue: true, selectionText: undefined };
}
